import * as d3 from 'd3'
export default {


  methods: {
    set_GaugeValues() {
      this.angle = {
        size: 180,
        count: 180 / 51.4,
        outY: -this.gauge.circle.radius,
        inY: this.gauge.circle.tickness - this.gauge.circle.radius,
        gridY: [],
        start: 269,
        end: 450,
      }
      this.angle.gridY = [this.angle.inY+5, this.angle.inY+7, this.angle.inY+10]
      this.gauge.circle.cx = this.gauge.circle.x + this.gauge.circle.radius
      this.gauge.circle.cy = this.gauge.circle.y + this.gauge.circle.radius
    },

    fnc_Gauge_Router(selection, data_, idx) {
      

      this.gmx_ColorV2Sets()
      this.set_GaugeValues()

      let angle = this.angle
      let circle = this.gauge.circle

      let gauge = selection
      .append('g')
      .attr('transform', `translate(${circle.cx},${circle.cy})`)

      var arcBg = d3.arc()
      .innerRadius(circle.radius)
      .outerRadius(circle.radius - circle.tickness)
      .startAngle(angle.start * Math.PI / 180)
      .endAngle(angle.end * Math.PI / 180)

      // ForeGround
      gauge
      .append('path')
      .attr('transform', `translate(${0}, ${0})`)
      .attr('d', arcBg).attr('fill', `url(#${this.localId}_BP_V2)`)

      this.gauge_Grid(selection) 

      this.gauge_WhiteGrid(selection)
      this.gauge_Actual(selection, data_, idx)
      this.gauge_WhiteGrid(selection)

      this.gauge_Plan(selection, data_)
      this.gauge_Delta(selection, data_, idx)
    },

    gauge_Grid(selection) {
      let angle = this.angle
      let circle = this.gauge.circle

      let grid = selection
      .append('g')
      .attr('transform', `translate(${circle.cx},${circle.cy})`)

      let i = 0
      for (var n = angle.start; n <= angle.end; n += angle.count) {
        i += 1
        grid
        .append('polygon')
        .attr('points', ()=>{
          if(i==1 || i==26 || i ==52) return `-.7, ${angle.gridY[0]} .7, ${angle.gridY[0]} .4,${angle.gridY[2]} -.4,${angle.gridY[2]}`
          else return `-.7, ${angle.gridY[0]} .7, ${angle.gridY[0]} .4,${angle.gridY[1]} -.4,${angle.gridY[1]}`
        })
        .attr('fill', '#bcbcbc')
        .attr('transform', () => `rotate(${n+1.7}, 0, 0)`)
      }
      this.gmx_Text(grid, '', 0, angle.inY+19, 8, '#757575', 'middle', '', '50%')
      this.gmx_Text(grid, '', angle.inY + 16, 2, 8, '#757575', 'start', '', '0%')
      this.gmx_Text(grid, '', -angle.inY -14, 2, 8, '#757575', 'end', '', '100%')
    },

    gauge_WhiteGrid(selection) {
      let angle = this.angle
      let circle = this.gauge.circle

      let whiteGrid = selection
      .append('g')
      .attr('transform', `translate(${circle.cx},${circle.cy})`)

      for (var n = angle.start; n <= angle.end; n += angle.count) {
        whiteGrid
        .append('polygon')
        .attr('points', `-1.5, ${angle.outY-1} 1.5, ${angle.outY-1} 1.15,${angle.inY+1} -1.15,${angle.inY+1}`)
        .attr('fill', 'white').attr('transform', () => `rotate(${n}, 0, 0)`)
      }
    },

    gauge_Plan(selection, data_) {

      let angle = this.angle
      let circle = this.gauge.circle
      let columns = this.gauge.columns
      let col = columns.find(f=> f.name == 'PLAN')
      let prog = data_[col.code]/100
      let fc = 270 + prog * 180

      let plan = selection
      .append('g')
      .attr('transform', `translate(${circle.cx},${circle.cy})`)

      plan
      .append('line')
      .attr('x1', 0).attr('y1', -circle.radius - 10)
      .attr('x2', 0).attr('y2', angle.inY)
      .attr('stroke', col.stroke).attr('stroke-width', 1)
      .attr('transform', () => `rotate(${270}, 0, 0)`)
      .transition().duration(500)
      .attr('transform', () => `rotate(${fc}, 0, 0)`)

      plan
      .append('circle')
      .attr('cx', 0).attr('cy', -circle.radius - 10)
      .attr('r', 2).attr('fill', 'white')
      .attr('stroke', col.stroke).attr('stroke-width', 1)
      .attr('transform', () => `rotate(${270}, 0, 0)`)
      .transition().duration(500)
      .attr('transform', () => `rotate(${fc}, 0, 0)`)


      // col = columns.find(f=> f.code == 'P_QTY')
      let cx = (circle.radius + 10) * Math.sin((180-fc) * Math.PI/180)
      let cy = (circle.radius + 10) * Math.cos((180-fc) * Math.PI/180)

      let value = selection
      .append('g')
      .attr('transform', `translate(${circle.cx},${circle.cy})`)

      value
      .append('text')
      .attr('transform', ()=> {
        let tr = ''
        if(prog <= .35) tr = `translate(${cx-5}, ${cy + col.tSize*0.36})`
        if(prog >= .65) tr = `translate(${cx+5}, ${cy + col.tSize*0.36})`
        if(prog > .35 && prog < .65) tr = `translate(${cx}, ${cy-9 + col.tSize*0.36})`
        return tr
      })
      .attr('font-size', col.tSize).attr('fill', col.tColor)
      .attr('text-anchor', ()=> {
        let align = ''
        if(prog <= .35) align = 'end'
        if(prog >= .65) align = 'start'
        if(prog > .35 && prog < .65) align = 'middle'
        return align
      })
      .attr('opacity', 0)
      .text(data_.P_CUM + col.unit)
      .transition().duration(500).attr('opacity', 1)
    },    

    gauge_Actual(selection, data_, idx) {
    
      // Gauge - Actual
      let angle = this.angle
      let circle = this.gauge.circle
      let title = this.gauge.title
      let columns = this.gauge.columns

      let stAngle = ''
      let proAn = (180/100) * data_.A_CUM
    
      var arc = d3.arc()
      .innerRadius(circle.radius)
      .outerRadius(circle.radius - circle.tickness)
      .startAngle(()=> stAngle || 270 * Math.PI / 180)
      .endAngle(() => angle.end * Math.PI / 180)

      let gauge = selection
      .append('g')
      .attr('transform', `translate(${circle.cx},${circle.cy})`)

      gauge
      .append('path')
      .attr('transform', `translate(0, 0)`)
      .attr('d', arc).attr('fill', `#E0E0DF`).attr('opacity', 1)
      .transition().duration(500)
      .attrTween('d', ()=> {
        let stAngle_ = (270 * Math.PI / 180)
        let interpolate = d3.interpolate(stAngle_, (270+proAn) * Math.PI / 180)
        return function(t) {
          stAngle = interpolate(t)
          return arc()
        }
      })

      // Actual Cumulative Progress
      gauge
      .append('text')
      .attr('transform', `translate(0, ${title.pro.tSize*0.26})`)
      .attr('font-size', title.pro.tSize).attr('fill', title.pro.tColor)
      .attr('text-anchor', title.pro.align)
      .text(title.pro.name)

      let act = gauge
      .append('g')
      .attr('id', `ACTUAL_${idx}_${this.localId}`)
      .attr('transform', `translate(0, 0)`)

      let col = columns.find(f=> f.name == 'PRO')
      act // Progress
      .append('text')
      .attr('id', `VAL_${idx}_${this.localId}`)
      .attr('x', 0).attr('y', -10).attr('font-size', col.tSize).attr('fill', col.tColor)
      .text(Number(data_[col.code].toFixed(1)))

      act // Unit
      .append('text')
      .attr('transform', `translate(${this.getNode(`#VAL_${idx}_${this.localId}`, 'width')+3}, -10)`)
      .attr('font-size', col.uSize).attr('fill', col.uColor)
      .text(col.unit)

      d3.select(`#ACTUAL_${idx}_${this.localId}`)
      .attr('transform', `translate(${-(this.getNode(`#ACTUAL_${idx}_${this.localId}`, 'width')/2)}, 0)`)
    },

    gauge_Delta(selection, data_, idx) {
      let circle = this.gauge.circle
      let title = this.gauge.title
      let columns = this.gauge.columns

      let delta = selection
      .append('g')
      .attr('transform', `translate(${circle.cx},${circle.cy})`)

      // Actual Cumulative Progress
      delta
      .append('text')
      .attr('transform', `translate(0, ${-40 + title.pro.tSize*0.26})`)
      .attr('font-size', title.pro.tSize).attr('fill', title.pro.tColor)
      .attr('text-anchor', title.pro.align)
      .text(title.delta.name)

      let value = delta
      .append('g')
      .attr('id', `DELTA_${this.localId}`)
      .attr('transform', `translate(0, -50)`)

      let col = columns.find(f=> f.name == 'DELTA')
      value // Progress
      .append('text')
      .attr('id', `DT_VAL_${this.localId}`)
      .attr('x', 0).attr('y', 0)
      .attr('font-size', col.tSize).attr('fill', this.gmx_deltaValue(data_[col.code]))
      .text(data_[col.code])

      let x_ = this.getNode(`#DT_VAL_${this.localId}`, 'width')
      value // Unit
      .append('text')
      .attr('id', `DT_UNIT_${this.localId}`)
      .attr('transform', `translate(${x_}, 0)`)
      .attr('font-size', col.uSize).attr('fill', this.gmx_deltaValue(data_[col.code]))
      .text(col.unit)

      x_ = x_ + this.getNode(`#DT_UNIT_${this.localId}`, 'width') + 2
      value // Aarow
      .append('path')
      .attr('transform', `translate(${x_}, -9) scale(.7)`)
      .attr('d', this.gmx_deltaValue(data_[col.code], 'icon'))
      .attr('fill', this.gmx_deltaValue(data_[col.code]))
      .attr('stroke-width', .5)

      d3.select(`#DELTA_${this.localId}`)
      .attr('transform', `translate(${-(this.getNode(`#DELTA_${this.localId}`, 'width')/2)}, -50)`)
    },
    
  }
}